<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-18 09:32:49
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 10:47:50
 * @FilePath: /privacy-web/src/components/The/TheLogo.vue
-->
<template>
  <div
    @click="$router.push('/home-page-tile')"
    class="logo"
    :class="{ 'logo-mobile': isMobile }"
  ></div>
</template>
<script>
export default { name: "TheLogo" };
</script>
<style lang="scss" scoped>
.logo {
  width: calc($multiple * 87px);
  height: calc($multiple * 30px);
  background: url("@/assets/images/logo.png") no-repeat;
  cursor: pointer;
  background-size: contain !important;
  flex-shrink: 0;
}
// .logo {
//   width: 1.4rem;
//   height: 0.49rem;
//   background: url("@/assets/images/logo.png") no-repeat;
//   cursor: pointer;
//   background-size: contain !important;
// }
.logo-mobile {
  width: 3.74rem;
  height: 1.33rem;
  background: url("@/assets/images/mobile-logo.png") no-repeat;
}
</style>
